// extracted by mini-css-extract-plugin
export default {"cover":"cover_cover__NhWl2"};